import { CellContext } from "@tanstack/react-table";
import { Link } from "react-router";

import { Brand } from "../../../types/brand";
import { mapModelIcon, ModelIcons } from "../../../types/models";
import { TableData, ScoreDataByEntity } from "../../Table/types";

export const renderCellValue = (info: CellContext<TableData, unknown>) => info.getValue();

export function buildColumns(selectBrands: Brand[]) {
  return [
    {
      id: "models",
      accessorKey: "models",
      header: "Models",
      cell: renderCellValue,
    },
    ...selectBrands.map((brand, brandIndex) => {
      const groupId = `brand_group_${brandIndex}`;
      return {
        id: groupId,
        accessorKey: groupId,
        header: brand.name,
        meta: { brandId: brand.id },
        cell: renderCellValue,
      };
    }),
  ];
}

export function buildData<
  TModel extends { id: number; name: string; data?: { version?: string } | null },
>(params: {
  models: TModel[];
  modelsDailyBaseRoute: string;
  selectBrands: Brand[];
  scorePrompt: ScoreDataByEntity;
  isScoreLoading: boolean;
}): TableData[] {
  const { models, modelsDailyBaseRoute, selectBrands, scorePrompt, isScoreLoading } = params;

  const rows: TableData[] = [];

  for (const model of models) {
    const row: TableData = {
      models: {
        label: <Link to={`${modelsDailyBaseRoute}${model.id}`}>{`${model.name} ${model.data?.version}`}</Link>,
        Icon: mapModelIcon(model.name.toLowerCase() as ModelIcons),
      },
    };

    for (let brandIndex = 0; brandIndex < selectBrands.length; brandIndex++) {
      const brand = selectBrands[brandIndex];
      const groupId = `brand_group_${brandIndex}`;
      const score = scorePrompt?.[String(brand.id)]?.[String(model.id)];

      row[groupId] = {
        loader: isScoreLoading,
        response: score?.response_id,
        metrics: {
          visibility: score?.value,
          sentiment: score?.sentiment_score,
          ranking: score?.position,
        },
      };
    }

    rows.push(row);
  }

  return rows;
}

